// How Media AI lays out a reply's pictures — kept apart from the page so it
// can be tested without loading the page (and its Markdown renderer).

/**
 * Grid for a reply's pictures: as before for up to 4 made pictures or 8 web
 * photos; more columns for the larger sets (up to 30) so they stay scannable.
 */
export const outputGridClass = (outputs) => {
  const count = outputs.length;
  if (count <= 1) return 'grid-cols-1';
  const web = outputs.some((o) => o.source);
  if (web) return count > 8 ? 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4' : 'grid-cols-2 lg:grid-cols-3';
  return count > 4 ? 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4' : 'grid-cols-1 sm:grid-cols-2';
};

/** A reply's pictures grouped under their topic titles (outputs carry the section index). */
export const groupBySection = (message) => (message.sections || [])
  .map((section, index) => ({ title: section.title, outputs: (message.outputs || []).filter((o) => o.section === index) }))
  .filter((group) => group.outputs.length);
